module.exports = __webpack_public_path__ + "img/outlaw.9b6a50b3.jpg";